// extracted by mini-css-extract-plugin
export var menuIcon = "_ti-0";
export var menuIconInline = "_ti-1";